$bog_vmap_app_pane $mol_view
	attr *
		^
		tabindex \-1
		bog_vmap_app_pane_tool <= tool
		bog_vmap_app_pane_hand <= hand
	tool? \select
	grip? false
	hand false
	tool_select? false
	tool_board? false
	tool_text? false
	tool_hand? false
	editable true
	board_draw? null
	text_draw? null
	text_enabled false
	text_new? \
	text_new_style *
	text_new_submit? null
	text_new_key? null
	node_resize? null
	node_text* \
	node_text_kind* \
	node_text_write? null
	node_delete? null
	node_copy? null
	node_wrap? null
	node_group? null
	node_ungroup? null
	ungroup_enabled false
	node_reset_all? null
	reset_enabled false
	node_clone? null
	leave? null
	key_down* false
	key_up* null
	scene_bundle \
	scene_html \
	pack_uri \
	theme \
	doc_src \
	doc_css \
	spots? *
	guides? *
	picked? /string
	inner \
	doc_js *
	doc_root \
	libs /$bog_vmap_bridge_part
	carrying false
	wires /$bog_vmap_lang_link
	part_ports* /$bog_vmap_app_wire_port
	part_overs* /string
	link_add? null
	link_drop? null
	containers /string
	doc_names /string
	doc_paths /string
	doc_key \
	node_title? \
	axis* \
	tree_move? null
	carry_at? null
	carry_drop? null
	files_drop? null
	file_over? null
	file_take? null
	event *
		^
		dragover? <=> file_over? null
		drop? <=> file_take? null
	values? *
	handshake*? 0
	ready false
	stalled? false
	warmed? false
	entered? null
	inside false
	world_center /number
	free_spot /number
	key_field* false
	part_size* null
	copy_spot* null
	camera_fit? null
	camera_reset? null
	node_show? null
	zoom_out? null
	zoom_in? null
	zoom_full? null
	zoom_title \
	node_error* \
	scene_restart? null
	error_at*? \
	error_node*? \
	pack_note \
	scene_lost? \
	error \
	isolation \
	camera_shift? $mol_vector_2d<number> /
		0
		0
	camera_zoom? 1
	scene_generation? 0
	Scene* $bog_vmap_app_pane_frame
		html <= scene_html
	sub /
		<= Field $bog_vmap_app_pane_field
			style <= field_style *
			sub <= field_sub /$mol_view
			camera_shift? <=> camera_shift?
			camera_zoom? <=> camera_zoom?
	Overlay $bog_vmap_app_pane_overlay
		style <= overlay_style *
		frames <= frames /string
		frame_style* <= frame_style* *
		inner <= inner_shown \
		inner_style <= inner_style *
		press? <=> node_press? null
		move? <=> node_move? null
		release? <=> node_release? null
		lost? <=> node_lost? null
		away? <=> node_away? null
		context? <=> node_context? null
	Wire $bog_vmap_app_wire
		lines <= wire_lines /$bog_vmap_app_wire_line
		dots <= wire_dots /$bog_vmap_app_wire_dot
		drag_geometry <= wire_drag_geometry \
	Values $mol_view
		sub <= value_labels /$mol_view
	Names $mol_view
		sub <= name_views /$mol_view
	Marks $mol_view
		sub <= error_marks /$mol_view
	Label* $bog_vmap_app_pane_label
		style <= label_style* *
		lines <= label_lines* /string
	Name* $mol_view
		style <= name_style* *
		attr *
			^
			bog_vmap_app_pane_name_picked <= name_picked* false
		event *
			^
			click? <=> name_press*? null
			dblclick? <=> name_edit*? null
		sub /
			<= name_title* \
	Name_field* $mol_string
		style <= name_style* *
		hint \имя узла
		value? <=> name_draft*? \
		submit? <=> name_submit*? null
		event *
			^
			blur? <=> name_submit*? null
			keydown? <=> name_key*? null
	Mark* $mol_view
		style <= mark_style* *
		attr *
			^
			title <= mark_hint* \
		sub /
			\!
	Insert $mol_view
		style <= insert_style *
	Sizing $mol_view
		style <= sizing_style *
		sub /
			<= sizing_note \
	Text_new $mol_string
		style <= text_new_style *
		hint \текст
		value? <=> text_new? \
		submit? <=> text_new_submit? null
		event *
			^
			blur? <=> text_new_submit? null
			keydown? <=> text_new_key? null
	Text_field* $mol_string
		style <= text_style* *
		hint \текст узла
		value? <=> text_draft*? \
		submit? <=> text_submit*? null
		event *
			^
			blur? <=> text_submit*? null
			keydown? <=> text_key*? null
	Say $mol_view
		style <= say_style *
		sub /
			<= say_note \
	Band $mol_view
		style <= band_style *
	Draft $mol_view
		style <= draft_style *
	Snap_hint* $mol_view
		style <= snap_hint_style* *
	Guide* $mol_view
		style <= guide_style* *
		attr *
			^
			bog_vmap_app_pane_guide_picked <= guide_picked* false
			bog_vmap_app_pane_guide_axis <= guide_axis* \
			title \Направляющая: тяните мышью, обратно на линейку или Delete — убрать
		event *
			^
			pointerdown? <=> guide_press*? null
			pointermove? <=> guide_move*? null
			pointerup? <=> guide_release*? null
	Gap* $mol_view
		style <= gap_style* *
		sub /
			<= gap_title* \
	Ruler* $mol_view
		style <= ruler_style* *
		sub <= ruler_sub* /$mol_view
		attr *
			^
			title \Линейка: тяните с неё направляющую
		event *
			^
			pointerdown? <=> ruler_press*? null
			pointermove? <=> guide_move*? null
			pointerup? <=> guide_release*? null
	Tick* $mol_view
		style <= tick_style* *
		sub /
			<= tick_title* \
	Span* $mol_view
		style <= span_style* *
	Ghost* $mol_view
		style <= ghost_style* *
	Menu* $bog_vmap_app_menu
		showed? <=> menu_showed? false
		left <= menu_left \
		top <= menu_top \
		on_node <= menu_on_node false
		editable <= editable
		copy? <=> node_copy?
		remove? <=> node_delete?
		wrap? <=> node_wrap?
		group? <=> node_group?
		ungroup? <=> node_ungroup?
		ungroup_enabled <= ungroup_enabled
		reset? <=> node_reset_all?
		reset_enabled <= reset_enabled
		parent? <=> menu_parent? null
		parent_enabled <= menu_parent_enabled false
		enter? <=> menu_enter? null
		board? <=> menu_board? null
		fit? <=> camera_reset?

$bog_vmap_app_pane_field $mol_view
	camera_shift? $mol_vector_2d<number> /
		0
		0
	camera_zoom? 1
	plugins /
		^
		<= Touch $mol_touch
			allow_draw false
			allow_pan true
			allow_zoom true
			pan? <=> camera_shift?
			zoom? <=> camera_zoom?

$bog_vmap_app_pane_overlay $mol_view
	frames /string
	frame_style* *
	inner \
	inner_style *
	press? null
	move? null
	release? null
	lost? null
	away? null
	context? null
	event *
		^
		pointerdown? <=> press? null
		pointermove? <=> move? null
		pointerup? <=> release? null
		pointercancel? <=> release? null
		lostpointercapture? <=> lost? null
		pointerleave? <=> away? null
		contextmenu? <=> context? null
	Frame* $mol_view
		style <= frame_style* *
		sub /
			<= Handle_nw $bog_vmap_app_pane_handle corner \nw
			<= Handle_n $bog_vmap_app_pane_handle corner \n
			<= Handle_ne $bog_vmap_app_pane_handle corner \ne
			<= Handle_e $bog_vmap_app_pane_handle corner \e
			<= Handle_se $bog_vmap_app_pane_handle corner \se
			<= Handle_s $bog_vmap_app_pane_handle corner \s
			<= Handle_sw $bog_vmap_app_pane_handle corner \sw
			<= Handle_w $bog_vmap_app_pane_handle corner \w
	Inner $mol_view
		style <= inner_style *

$bog_vmap_app_pane_label $mol_view
	lines /string
	sub <= rows /$mol_view
	Row* $mol_view
		sub <= row_cells* /$mol_view
	Cell* $mol_view
		sub /
			<= cell_text* \

$bog_vmap_app_pane_handle $mol_view
	corner \
	attr *
		^
		bog_vmap_app_pane_handle_corner <= corner

$bog_vmap_app_pane_frame $mol_frame
	attr *
		sandbox \allow-scripts
		^
		src null
